import React, { useState, useEffect } from "react";
import Utils from "../../utils/Utils";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import Link from "next/link";

const TableCellRegressionDiff = ({
  leagueType = "",
  rankValue = "",
  children = "",
  props,
  conferenceTeamCount = 0,
  hideGradients = false,
  hideRank = false,
  style = {},
  link = "",
  columnType = "off",
  hideArrows = false,
  dataName = "",
}) => {
  const [gradientColor, setGradientColor] = useState("");
  const cellData = Number.parseFloat(children);

  useEffect(() => {
    if (!hideGradients) {
      setGradientColor(
        leagueType !== "conference"
          ? Utils.getGradients({ leagueType, rank: rankValue })
          : Utils.getConfGradient({ rank: rankValue, conferenceTeamCount })
      );
    }
  }, [leagueType, rankValue, conferenceTeamCount]);

  return link.length > 0 ? (
    <td {...props} style={style} data-name={dataName}>
      <Link href={link}>
        {columnType === "off" && cellData > 0 && !hideArrows ? (
          <AiOutlineArrowDown color="#D82011" className="arrow down" />
        ) : null}
        {columnType === "off" && cellData < 0 && !hideArrows ? (
          <AiOutlineArrowUp color="#208502" className="arrow up" />
        ) : null}

        {columnType === "def" && cellData > 0 && !hideArrows ? (
          <AiOutlineArrowUp color="#208502" className="arrow up" />
        ) : null}
        {columnType === "def" && cellData < 0 && !hideArrows ? (
          <AiOutlineArrowDown color="#D82011" className="arrow down" />
        ) : null}

        <span>{typeof children === "string" ? children?.replace("-", "") : children}</span>

        {hideGradients && !hideRank ? <small>{rankValue}</small> : null}
        {!hideGradients && !hideRank ? <small style={{ background: gradientColor }}>{rankValue}</small> : null}
      </Link>
    </td>
  ) : (
    <td {...props} style={style} data-name={dataName}>
      {columnType === "off" && cellData > 0 && !hideArrows ? (
        <AiOutlineArrowDown color="#D82011" className="arrow down" />
      ) : null}
      {columnType === "off" && cellData < 0 && !hideArrows ? (
        <AiOutlineArrowUp color="#208502" className="arrow up" />
      ) : null}

      {columnType === "def" && cellData > 0 && !hideArrows ? (
        <AiOutlineArrowUp color="#208502" className="arrow up" />
      ) : null}
      {columnType === "def" && cellData < 0 && !hideArrows ? (
        <AiOutlineArrowDown color="#D82011" className="arrow down" />
      ) : null}
      <span>{typeof children === "string" ? children?.replace("-", "") : children}</span>

      {hideGradients && !hideRank ? <small>{rankValue}</small> : null}
      {!hideGradients && !hideRank ? <small style={{ background: gradientColor }}>{rankValue}</small> : null}
    </td>
  );
};

export default TableCellRegressionDiff;
